export default {
    namespaced: true,
    state: {
        doctortype: JSON.parse(localStorage.getItem('doctortype')),
    },
    getters: {
        getdoctortype(state) {
            return state.doctortype;
        },

    },
    mutations: {
        DoctorType(state, doctortype) {
                localStorage.setItem('doctortype', JSON.stringify(doctortype));
                state.doctortype = doctortype;
        }
    },
    actions: {
        setdoctortype({commit}, doctortype) {
            commit('DoctorType', doctortype);
        },
    },
};

